const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nuevos i\u0301conos 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Light-S"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.16,68.9a2.64,2.64,0,0,0,2.63-2.59V26l-.19-5.62,3,3.13L67.78,30a2.51,2.51,0,0,0,1.85.83,2.39,2.39,0,0,0,1.66-4.15L58.06,13.82a2.39,2.39,0,0,0-1.9-.88,2.44,2.44,0,0,0-2,.88L41,26.66a2.37,2.37,0,0,0-.78,1.76,2.34,2.34,0,0,0,2.44,2.39A2.6,2.6,0,0,0,44.49,30l6.15-6.44,3-3.17L53.47,26V66.31A2.66,2.66,0,0,0,56.16,68.9ZM22.81,100.79H89.46c7.71,0,11.62-3.86,11.62-11.48V67c0-3.22-.44-4.78-2-6.73l-12.85-16C81.79,38.87,80,37.6,73.59,37.6h-7v4.79H74a7.6,7.6,0,0,1,6.88,3.27L94.1,62.31c1.41,1.76.92,2.49-1,2.49H68a2.56,2.56,0,0,0-2.64,2.83v.15a9.23,9.23,0,1,1-18.45,0v-.15a2.6,2.6,0,0,0-2.69-2.83h-25c-2,0-2.34-.83-1-2.49L31.3,45.76c2.25-2.74,4.06-3.37,6.94-3.37h7.47V37.6h-7c-6.45,0-8.21,1.27-12.7,6.79L13.19,60.31c-1.56,1.95-2,3.51-2,6.73V89.31C11.19,96.93,15.09,100.79,22.81,100.79Zm.09-5.42c-4,0-6.29-2.15-6.29-6.35V69.73H41.75c.78,7.28,6.74,12.5,14.41,12.5S69.73,77,70.51,69.73H95.66V89c0,4.2-2.3,6.35-6.3,6.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.4101ba6169d3c1b479435cb4e982697c.svg";
export { ForwardRef as ReactComponent };